<template>
    <div>
        <st-button
            v-can:create="'documentTemplate'"
            variant="secondary"
            :callback="createFrom"
        >
            <i class="fa fa-plus"></i>
            {{ $t('DOCUMENT_TEMPLATE.LIST.ADD_BUTTON') }}
        </st-button>
    </div>
</template>

<script>
    export default {
        name: 'DocumentTemplateListToolbar',
        methods: {
            createFrom() {
                this.$router.push({ name: 'documentTemplateNew' });
            },
        },
    };
</script>
